import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';

class IconSocialSettings extends React.Component {
  getChildContext() {
    const {
      socialSprite,
      socialRoundSprite
    } = this.props;
    return {
      socialSprite,
      socialRoundSprite
    };
  }
  render() {
    const {
      children
    } = this.props;
    return children;
  }
}
IconSocialSettings.displayName = "IconSocialSettings";
_defineProperty(IconSocialSettings, "propTypes", {
  socialSprite: PropTypes.string.isRequired,
  socialRoundSprite: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
});
IconSocialSettings.childContextTypes = {
  socialSprite: PropTypes.string,
  socialRoundSprite: PropTypes.string
};

export { IconSocialSettings as default };
